import * as React from 'react'
import {Box,  
    Dialog, DialogContent, DialogActions, 
    DialogTitle, DialogContentText, TextField, Button} from '@mui/material'
import {styled} from '@mui/material/styles'
import axios from 'axios'

import SendIcon from '@mui/icons-material/Send'

const CustomDialog = styled(Dialog)(({theme})=>({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
      },
      '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
      },
  
  }));

export const AdminDocumentResponse =({open, onClose, document})=>{

    const context = JSON.parse(window.localStorage.getItem('usercontext'))
    const admincontext = JSON.parse(window.localStorage.getItem('context'))
    
    const responsible_employee = context.first_name + ' ' + context.last_name
   
    const [feedbackParagraphOne, setfeedbackParagraphOne] = React.useState("")
    const [userEmail, setUserEmail] = React.useState(context.email)
    const [loading, setLoading] = React.useState(false)
    const [disabled, setDisabled] = React.useState(false)
    
    
    const pageURL = window.location.pathname
    const browser = window.navigator.userAgent


   
    
    

    const paragraphOneChange = (event) =>{
        setfeedbackParagraphOne(event.target.value)
    }
    
    const feedbackEmailChange = (event) =>{
        setUserEmail(event.target.value)
        
    }
    
    const sendResponse = () =>{
        setLoading(true)
        setDisabled(true)
        axios({
            method:'POST',
            url: 'api/oracle7/documentfeedback',
            data: {url: pageURL,
                   customer_first_name: context.first_name,
                   customer_last_name: context.last_name,
                   browser_info: browser,
                   paragraphOne: feedbackParagraphOne,
                   email: userEmail,
                   responseEmail: admincontext.email,
                   employee_first_name: admincontext.first_name,
                   responsible_employee: responsible_employee,
                   customer_number: context.customer_number,
                   file_name: document.file_name
                   }

        })

    .then(res=>{
        if(res.status===200){
            setLoading(false)
            setDisabled(false)
            onClose()
        } else {
            setLoading(false)
            setDisabled(false)
        }
    })
    
}

return (
      
    <Box>   
    <CustomDialog open={open} onClose={onClose}>
        <DialogTitle>Enter Response to the Customer Below</DialogTitle>
        <DialogContent dividers>
            <DialogContentText sx={{color:'black'}}>
                Response to the Customer
            </DialogContentText>
                <TextField
                fullWidth
                id='First_Paragraph'
                label='Response Email'
                multiline
                maxRows={25}
                value={feedbackParagraphOne}
                onChange={paragraphOneChange}
                />
        
            <DialogContentText sx={{color:'black'}}>
                Email
            </DialogContentText>
                <TextField
                disabled
                id='email'
                label='Confirm Email Address'
                value={userEmail}
                onChange={feedbackEmailChange}
                />
            </DialogContent>
            <DialogActions>
            <Button variant='contained' color='primary' onClick={sendResponse} endIcon={<SendIcon />} loading={loading}>Send Response</Button>
            <Button variant='contained' color='secondary' onClick={onClose} disabled={disabled}>Cancel</Button>
            </DialogActions>
    </CustomDialog>
    </Box>



         







)




}